<template>
  <div class="construction-cost-budget">
    <SimpleTable
      ref="constructionCostBudget"
      table-code="constructionCostBudget"
      :menus="['查询', '批量修改', '插入', '批量删除']"
      :rightFrozenColCount="1"
      :columns="columns"
      :data="tableData"
      :loading="loading"
      @modify-data-change="onModifyDataChange"
    />

    <DesignDetail ref="costBudgetDetail" @close="getTableData" />
  </div>
</template>

<script>
import { tableMixin } from '@/utils/tableMixin'
import SimpleTable from '@/components/SimpleTable/index.vue'
import { sortRecords, getOptions, addCbFn } from '@/utils/index'
import DesignDetail from './DesignDetail.vue'

export default {
  name: 'ConstructionCostBudget',
  mixins: [tableMixin],
  components: {
    SimpleTable,
    DesignDetail
  },
  data() {
    return {
      tableData: [],
      columns: [
        {
          field: 'name',
          title: '建安成本预算名称',
          canEdit: true,
          canModify: true
        },
        {
          field: 'cbeName',
          title: '施工预算',
          editModal: {
            columns: [{ field: 'name', title: '施工预算' }],
            options: async () => {
              const res = await this.$service.get(
                '/construction-budget-estimate/list'
              )
              return res?.data || []
            },
            confirm: (selectedCellInfos, res) => {
              const row = res[0][0].originData
              selectedCellInfos.forEach(cells => {
                const obj = cells[0].originData
                this.$set(obj, 'cbeName', row.name)
                this.$set(obj, 'cbeId', row.id)
              })
            }
          },
          canModify: true
        },
        {
          field: 'billType',
          title: '清单类型',
          editor: {
            type: 'select',
            options: [
              { label: '2013清单', value: '2013清单' },
              { label: '2024清单', value: '2024清单' },
              { label: '非国标清单', value: '非国标清单' }
            ]
          },
          editModal: {
            columns: [{ field: 'name', title: '清单类型' }],
            options: [
              { name: '2013清单' },
              { name: '2024清单' },
              { name: '非国标清单' }
            ],
            confirm: (selectedCellInfos, res) => {
              const row = res[0][0].originData
              selectedCellInfos.forEach(cells => {
                const obj = cells[0].originData
                this.$set(obj, 'billType', row.name)
              })
            }
          },
          canEdit: true,
          canModify: true
        },
        {
          field: 'projectName',
          title: '项目名称'
        },
        {
          field: 'amount',
          title: '预算金额',
          width: 100
        },
        {
          field: 'createdUnitName',
          title: '编制单位'
        },
        {
          field: 'sysCreatedDate',
          title: '编制日期',
          editor: { type: 'date' }
        },
        {
          field: 'operation',
          title: '操作',
          width: 40,
          cellType: 'text',
          buttons: [
            {
              action: 'import',
              text: '建安成本预算',
              click: (row, record) => {
                this.import(row, record)
              }
            }
          ]
        }
      ],
      loading: false
    }
  },
  created() {
    this.getTableData()
  },
  mounted() {
    // 页面初始化逻辑
  },
  methods: {
    // 页面方法
    async getTableData() {
      this.loading = true
      const res = await this.$service.get('/project-unit-budget/list')
      this.loading = false
      this.tableData = sortRecords(res?.data || [])
    },

    import(row) {
      if (!this.tableData[row]?.id) {
        this.$message.warning('请先保存该数据')
        return
      }
      this.$refs.costBudgetDetail.show(this.tableData[row])
    },

    async onModifyDataChange(getModifyData, cleanModifyData) {
      await addCbFn(
        this.$service,
        '/project-unit-budget/batch',
        getModifyData,
        cleanModifyData
      )

      this.getTableData()
    }
  }
}
</script>

<style scoped lang="less">
.construction-cost-budget {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 100%;
}
</style>
